var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import store from "../../reduxStore/store";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSalesRepCouponData, createCouponAction, removeCouponAction } from "../../reduxStore/actions/salesRepDataAction";
import { useTranslation } from "react-i18next";
import { isNullOrEmpty, useDeviceQueries } from "../../shared/Utilites";
import { isLoading } from "../../services/behaviorSubjectService";
export function DiscountCouponBL() {
    var _this = this;
    var _a, _b;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _c = useState([]), viewCouponData = _c[0], setViewCouponData = _c[1];
    var _d = useState(t("discountCoupon_button3")), createOneCoupon = _d[0], setcreateOneCoupon = _d[1];
    var _e = useState(false), isDelete = _e[0], setIsDelete = _e[1];
    var _f = useState(0), removeIndex = _f[0], setRemoveIndex = _f[1];
    var _g = useState("ST_DC_Pointer_Events_All"), pointerEvents = _g[0], setPointerEvents = _g[1];
    var _h = useState({ discountCode: "", discountCodeErrMsg: "", discountValue: "", discountValueErrMsg: "" }), inputState = _h[0], setInputState = _h[1];
    var discountCouponData = store.getState().salesRepData.baseData;
    var _j = useState(t("discountCoupon_contentHeading4PlaceHolder1") +
        " " +
        (discountCouponData && ((_a = Object.keys(discountCouponData)) === null || _a === void 0 ? void 0 : _a.length) !== 0 && (discountCouponData === null || discountCouponData === void 0 ? void 0 : discountCouponData.CouponCodeForSalesRep) !== null
            ? (_b = discountCouponData === null || discountCouponData === void 0 ? void 0 : discountCouponData.CouponCodeForSalesRep) === null || _b === void 0 ? void 0 : _b.DiscountCode
            : "-") +
        " " +
        t("discountCoupon_contentHeading4PlaceHolder2")), copyDiscountText = _j[0], setcopyDiscountText = _j[1];
    var createCouponBtnEnabled = inputState.discountCode != "" && inputState.discountValue != "";
    var _k = useState(discountCouponData ? discountCouponData.select.SalesrepCoupon : {}), oneTimeCouponCode = _k[0], setOneTimeCouponCode = _k[1];
    var _l = useState({ msg: "", open: false }), alertMsg = _l[0], setAlertMsg = _l[1];
    var _m = useState(false), openCommissionDialog = _m[0], setOpenCommissionDialog = _m[1];
    var isMobile = useDeviceQueries();
    var headerMap = {
        ProductType: {
            first: "Product Type",
            second: "Commission",
        },
        Product: {
            first: "Product Name",
            second: "Commission",
        },
        Collection: {
            first: "Collection Name",
            second: "Commission",
        },
        TieredGroup: {
            first: "Tiers",
            second: "Percentage",
        },
    };
    // Delete confirmation states
    var _o = useState(null), deleteConfirmation = _o[0], setDeleteConfirmation = _o[1];
    var _p = useState({}), deleteLink = _p[0], setDeleteLink = _p[1];
    var _q = useState(), deleteCouponDataObject = _q[0], setDeleteCouponDataObject = _q[1];
    useEffect(function () {
        var _a, _b;
        setcreateOneCoupon(t("discountCoupon_button3"));
        setcopyDiscountText(t("discountCoupon_contentHeading4PlaceHolder1") +
            " " +
            (discountCouponData && ((_a = Object.keys(discountCouponData)) === null || _a === void 0 ? void 0 : _a.length) !== 0 && (discountCouponData === null || discountCouponData === void 0 ? void 0 : discountCouponData.CouponCodeForSalesRep) !== null
                ? (_b = discountCouponData === null || discountCouponData === void 0 ? void 0 : discountCouponData.CouponCodeForSalesRep) === null || _b === void 0 ? void 0 : _b.DiscountCode
                : "-") +
            " " +
            t("discountCoupon_contentHeading4PlaceHolder2"));
    }, [t]);
    useEffect(function () {
        handleViewCouponOpen();
    }, []);
    var handleViewCouponOpen = function () { return __awaiter(_this, void 0, void 0, function () {
        var responseData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(getSalesRepCouponData())];
                case 1:
                    responseData = _a.sent();
                    if (!isNullOrEmpty(responseData)) {
                        setViewCouponData(store.getState().salesRepData.viewCouponData);
                    }
                    isLoading.next(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var changeValue = function (e) {
        var _a;
        if (e.target.name === "discountCode") {
            setInputState(function (values) { return (__assign(__assign({}, values), { discountCode: e.target.value })); });
            if (e.target.value === "") {
                setInputState(function (values) { return (__assign(__assign({}, values), { discountCodeErrMsg: t("addCustomer_leadEmptyErrrorMsg") })); });
            }
            else {
                setInputState(function (values) { return (__assign(__assign({}, values), { discountCodeErrMsg: "" })); });
            }
        }
        else {
            setInputState(function (values) { return (__assign(__assign({}, values), { discountValue: e.target.value })); });
            if (e.target.value > ((_a = discountCouponData === null || discountCouponData === void 0 ? void 0 : discountCouponData.DiscountAndCommissionForCoupon) === null || _a === void 0 ? void 0 : _a.SalesRepMaxDiscount)) {
                setInputState(function (values) { return (__assign(__assign({}, values), { discountValueErrMsg: t("discountCoupon_contentHeading8PlaceHolder") })); });
            }
            else {
                setInputState(function (values) { return (__assign(__assign({}, values), { discountValueErrMsg: "" })); });
            }
        }
    };
    var createCoupon = function () { return __awaiter(_this, void 0, void 0, function () {
        var createCouponData, successData, refreshedCouponData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    createCouponData = { discountCode: inputState.discountCode, discountValue: inputState.discountValue };
                    setcreateOneCoupon(t("createCoupon_btnlbl1"));
                    setPointerEvents("ST_DC_Pointer_Events_None");
                    return [4 /*yield*/, dispatch(createCouponAction(createCouponData))];
                case 1:
                    successData = _a.sent();
                    if (!(successData === "Coupon Created")) return [3 /*break*/, 3];
                    setcreateOneCoupon(t("createCoupon_btnlbl2"));
                    setAlertMsg({ msg: t("createCoupon_btnlbl2"), open: true, severity: "success" });
                    return [4 /*yield*/, dispatch(getSalesRepCouponData())];
                case 2:
                    refreshedCouponData = _a.sent();
                    if (refreshedCouponData && refreshedCouponData.length > 0) {
                        setViewCouponData(store.getState().salesRepData.viewCouponData);
                    }
                    setTimeout(function () {
                        setPointerEvents("ST_DC_Pointer_Events_All");
                        setcreateOneCoupon(t("discountCoupon_button3"));
                        setInputState({ discountCode: "", discountCodeErrMsg: "", discountValue: "", discountValueErrMsg: "" });
                    }, 3000);
                    return [3 /*break*/, 4];
                case 3:
                    setAlertMsg({ msg: successData, open: true, severity: "error" });
                    setPointerEvents("ST_DC_Pointer_Events_All");
                    setcreateOneCoupon(t("discountCoupon_button3"));
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Delete confirmation functions
    var deleteCouponWithConfirmation = function () { return __awaiter(_this, void 0, void 0, function () {
        var couponCode, couponId, salesRepId, deleteObject, removedItem, removedResponseData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    couponCode = deleteCouponDataObject === null || deleteCouponDataObject === void 0 ? void 0 : deleteCouponDataObject.delete_Coupon_Code;
                    couponId = deleteCouponDataObject === null || deleteCouponDataObject === void 0 ? void 0 : deleteCouponDataObject.delete_Coupon_Id;
                    salesRepId = deleteCouponDataObject === null || deleteCouponDataObject === void 0 ? void 0 : deleteCouponDataObject.delete_SalesRep_Id;
                    console.log(couponCode, couponId, salesRepId, "couponCode, couponId, salesRepId");
                    if (!(couponCode && couponId && salesRepId)) return [3 /*break*/, 2];
                    deleteObject = __assign({}, deleteLink);
                    removedItem = {
                        coupon: couponCode,
                        customerId: salesRepId,
                        couponid: couponId,
                    };
                    deleteObject[couponId] = true;
                    setDeleteLink(__assign({}, deleteObject));
                    return [4 /*yield*/, dispatch(removeCouponAction(removedItem))];
                case 1:
                    removedResponseData = _a.sent();
                    if (!isNullOrEmpty(removedResponseData)) {
                        delete deleteLink[couponId];
                        setDeleteConfirmation(null);
                        // Refresh the coupon data using existing method
                        setTimeout(function () {
                            setViewCouponData(store.getState().salesRepData.viewCouponData);
                        }, 2000);
                    }
                    else {
                        deleteObject[couponId] = false;
                        setDeleteLink(__assign({}, deleteObject));
                        setAlertMsg({ msg: "Error in deleting coupon", open: true, severity: "error" });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    setAlertMsg({ msg: "Error in deleting coupon", open: true, severity: "error" });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var openDeleteConfirmation = function (event, coupon, index) {
        setDeleteConfirmation(event.currentTarget);
        console.log(coupon, "coupon");
        setDeleteCouponDataObject({
            delete_Coupon_Code: coupon === null || coupon === void 0 ? void 0 : coupon.CouponeCode,
            delete_index: index,
            delete_Coupon_Id: coupon === null || coupon === void 0 ? void 0 : coupon.couponId,
            delete_SalesRep_Id: coupon === null || coupon === void 0 ? void 0 : coupon.SalesRepId,
        });
    };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertMsg({ msg: "", open: false });
    };
    return {
        viewCouponData: viewCouponData,
        isDelete: isDelete,
        removeIndex: removeIndex,
        pointerEvents: pointerEvents,
        changeValue: changeValue,
        createCoupon: createCoupon,
        t: t,
        inputState: inputState,
        discountCouponData: discountCouponData,
        createOneCoupon: createOneCoupon,
        createCouponBtnEnabled: createCouponBtnEnabled,
        oneTimeCouponCode: oneTimeCouponCode,
        handleAlertMsgClose: handleAlertMsgClose,
        alertMsg: alertMsg,
        openCommissionDialog: openCommissionDialog,
        setOpenCommissionDialog: setOpenCommissionDialog,
        isMobile: isMobile,
        deleteConfirmation: deleteConfirmation,
        setDeleteConfirmation: setDeleteConfirmation,
        deleteLink: deleteLink,
        deleteCouponDataObject: deleteCouponDataObject,
        openDeleteConfirmation: openDeleteConfirmation,
        deleteCouponWithConfirmation: deleteCouponWithConfirmation,
        headerMap: headerMap,
    };
}
export function CssConstants() {
    var isMobile = useDeviceQueries();
    var ST_CS_Display_discountCopun = {
        width: isMobile ? "100%" : "135px",
    };
    var ST_DC_tableContainer = {
        maxHeight: 340,
        border: "0.1px solid #bfbfbf",
        borderRadius: "8px",
        marginTop: "30px",
        "& tr:last-child td": {
            borderBottom: "0px !important",
        },
        "& th": {
            fontSize: "13px !important",
        },
        "& td": {
            padding: "6px !important",
        },
    };
    return { ST_CS_Display_discountCopun: ST_CS_Display_discountCopun, ST_DC_tableContainer: ST_DC_tableContainer };
}
